<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.questions', 2),
                        href: meta.links.questions_index,
                    },
                    {
                        name: $t('messages.questions_per_tag_analysis'),
                        href: null,
                    },
                ]"
            />
        </template>

        <EmptyState v-if="subjects.length === 0" picture />
        <div v-else class="flex flex-wrap gap-x-2">
            <AppButton
                element="InertiaLink"
                :href="subject.url"
                v-for="subject in subjects"
                :key="subject.id"
                class="flex gap-x-2"
            >
                {{ subject.text }}

                <IconCircleCheckFilled class="h-5 w-5 text-indigo-600" v-if="filters.subject_id == subject.id" />
            </AppButton>
        </div>

        <div v-if="!!form.subject_id" class="mt-3">
            <NavLinks :links="meta.navLinks.gradeLevels" />
        </div>

        <div v-if="!!form.subject_id">
            <form action="" @submit.prevent="filter">
                <div class="md:grid md:grid-cols-12 md:gap-6">

                    <div class="sm:col-span-2">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.activity_mode')" for="mode" />
                            <FormSelect
                                id="mode"
                                v-model="form.mode"
                                :options="options.modes"
                                class="mt-1 w-full"
                                :null-option-text="$t('messages.all')"
                            />
                            <FormError :value="form.errors.mode" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-2" >
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.y_axis')" for="y_axis" />
                            <FormSelect
                                id="y_axis"
                                v-model="form.y_axis"
                                :options="options.y_axis"
                                class="mt-1 w-full"
                                :null-option="false"
                            />
                            <FormError :value="form.errors.y_axis" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-2" v-if="filters.grade_level_id" >
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.group')" for="group_id"/>
                            <FormSelect
                                id="group_id"
                                v-model="form.group_id"
                                :options="options.groups"
                                class="mt-1 w-full"
                                :null-option-text="$t('messages.all')"
                            />
                            <FormError :value="form.errors.group_id" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-2" v-if="filters.group_id">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.student')" for="student_id" />
                            <FormSelect
                                id="student_id"
                                v-model="form.student_id"
                                :options="options.students"
                                class="mt-1 w-full"
                                :null-option-text="$t('messages.all')"
                            />
                            <FormError :value="form.errors.student_id" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-4">
                        <FormLabel :value="$tc('messages.tags', 2)" for="tag_ids" />
                        <div class="mt-1">
                            <SlideOverCheckboxInput v-model="form.tag_ids" :options="options.tags" />
                        </div>
                    </div>

                    <div class="sm:col-span-2">
                        <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                        <div class="mt-1">
                            <SubmitFormButton
                                :button-text="$t('messages.filter')"
                                :processing="form.processing"
                                is-filter
                            />
                        </div>
                    </div>
                </div>
            </form>

            <div v-if="graph !== null" class="mt-5">
                <EfficiencyGraphBubbleChart :options="graph" />
            </div>
            <EmptyState v-else-if="!!filters.difficulty" picture />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import EmptyState from '@/components/EmptyState.vue';
import AppButton from '@/components/AppButton.vue';
import { IconCircleCheckFilled } from '@tabler/icons-vue';
import AppCard from '@/Shared/AppCard.vue';
import AppWell from '@/Shared/AppWell.vue';
import { Tippy } from 'vue-tippy';
import MedallionLevels from '@/components/MedallionLevels.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import ApexGraph from '@/components/ApexGraph.vue';
import SlideOverCheckboxInput from '@/components/Forms/SlideOverCheckboxInput.vue';
import NavLinks from '@/components/NavLinks.vue';
import EfficiencyGraphBubbleChart from './partials/EfficiencyGraphBubbleChart.vue';

export default {
    components: {
        EfficiencyGraphBubbleChart,
        NavLinks,
        SlideOverCheckboxInput,
        ApexGraph,
        SubmitFormButton,
        FormInput,
        FormError,
        FormSelect,
        FormLabel,
        MedallionLevels,
        Tippy,
        AppWell,
        AppCard,
        AppButton,
        PanelPage,
        EmptyState,
        IconCircleCheckFilled,
    },
    layout: Layout,
    name: 'Index',
    props: ['subjects', 'graph', 'filters', 'options', 'meta'],
    data() {
        return {
            form: this.$inertia.form({
                subject_id: this.filters.subject_id,
                type: this.filters.type,
                mode: this.filters.mode,
                grade_level_id: this.filters.grade_level_id,
                group_id: this.filters.group_id,
                student_id: this.filters.student_id,
                y_axis: this.filters.y_axis,
                tag_ids: this.filters.tag_ids.map((id) => +id),
            }),
            showAll: false,
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
